export const skillsData = [
  "C++",
  "HTML",
  "CSS",
  "Bootstrap",
  "Javascript",
  "Git",
];
export const skillsData2 = [
  "React",
  "Angular",
  "Nodejs",
  "ExpressJS",
  "MongoDB",
  "mySQL",
];
